// Where an image upload happened, for the `source` property of upload events.
export function uploadSourceForPath(pathname: string | null | undefined): string {
  const path = pathname ?? ''
  if (path.includes('ai-assistant')) return 'ai_assistant'
  if (path.includes('interactive-paper')) return 'interactive_paper'
  if (path.includes('dynamic-paper')) return 'dynamic_paper'
  if (path.includes('exam-sphere')) return 'exam_sphere'
  return 'course'
}
